import {
  DEPO_ALL_SUCCESS,
  DEPO_CREATE,
  DEPO_HIDE_MODAL,
  DEPO_LOAD_ALL,
  DEPO_SHOW_MODAL,
  DEPO_SUCCESS,
  DEPO_UPDATE,
} from '../constants/DepoConst';
import { DEPO_FAILED } from '../constants/DepoConst';
import { DEPO_LOADING } from '../constants/DepoConst';
import { DEPO_LOAD } from '../constants/DepoConst';
import { HIDE_MODAL, SHOW_MODAL } from '../constants/DepoConst';
import { BRANCH_UPDATE } from '../constants/BranchConst';

export const success = (data) => {
  return {
    type: DEPO_SUCCESS,
    data,
  };
};

export const successAll = (data) => {
  return {
    type: DEPO_ALL_SUCCESS,
    data,
  };
};

export const showModal = (data) => {
  return {
    type: DEPO_SHOW_MODAL,
  };
};

export const hideModal = (data) => {
  return {
    type: DEPO_HIDE_MODAL,
  };
};

export const failed = () => {
  return {
    type: DEPO_FAILED,
  };
};

export const loading = () => {
  return {
    type: DEPO_LOADING,
  };
};

export const loaddepolist = (id) => {
  return {
    type: DEPO_LOAD,
    id,
  };
};

export const loadalldepo = ({ page: page, filter: filter }) => {
  return {
    type: DEPO_LOAD_ALL,
    page,
    filter,
  };
};

export const createdepo = (data) => {
  return {
    type: DEPO_CREATE,
    data,
  };
};

export const updatedepo = (data) => {
  return {
    type: DEPO_UPDATE,
    data,
  };
};
